import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('_UI_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = async () => {
        const {pkid: dpId, uiName} = map.root.data
        const bizMap = {dpId, prjId, sVer}

        openWindow(
            '/Ai',

            {
                bizMap,
                prjId,
                scene: 'GENERATE_UE',
                sVer,
                title: `用户界面: ${uiName}`,
            }
        )
    }

    return {
        label: '界面逻辑',
        onClick,
        ...props,
    }
}
